<template>
  <div class="gallery-container">
    <!-- Main Heading -->
    <h1 class="gallery-heading">Gallery</h1>
    <!-- Subheading -->
    <h2 class="gallery-subheading">Inauguration</h2>
    <!-- Image Grid -->
    <div class="gallery-grid">
      <div v-for="(image, index) in images" :key="index" class="gallery-item">
        <img :src="image.src" :alt="image.alt" class="gallery-image" />
      </div>
    </div>

    
    <h2 class="gallery-subheading">Magazine Release</h2>
  </div>
</template>

<script>
import { gsap } from 'gsap';
import image1 from '../assets/images/Innaguration/new.jpeg';
import image2 from '../assets/images/Innaguration/new2.jpeg';
import image3 from '../assets/images/Innaguration/new3.jpeg';

export default {
  name: 'GalleryPage',
  data() {
    return {
      images: [
        { src: image1, alt: 'Inauguration Image 1' },
        { src: image2, alt: 'Inauguration Image 2' },
        { src: image3, alt: 'Inauguration Image 3' },
      ],
    };
  },
  mounted() {
    // GSAP Animations
    gsap.from('.gallery-heading', {
      opacity: 0,
      y: -50,
      duration: 1,
      ease: 'power2.out',
    });
    gsap.from('.gallery-subheading', {
      opacity: 0,
      y: -30,
      duration: 1,
      delay: 0.3,
      ease: 'power2.out',
    });
    gsap.from('.gallery-item', {
      opacity: 0,
      scale: 0.8,
      stagger: 0.2,
      duration: 0.8,
      delay: 0.5,
      ease: 'back.out(1.7)',
    });
  },
};
</script>

<style scoped>
.gallery-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
}

.gallery-heading {
  font-size: 3rem;
  font-weight: bold;
  text-align: center;
  color: #1a202c;
  margin-bottom: 1rem;
}

.gallery-subheading {
  font-size: 1.5rem;
  color: #4a5568;
  margin-bottom: 2rem;
}

.gallery-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
}

.gallery-item {
  overflow: hidden;
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.gallery-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.gallery-image:hover {
  transform: scale(1.05);
}

/* Responsive Design */
@media (max-width: 768px) {
  .gallery-heading {
    font-size: 2.5rem;
  }

  .gallery-subheading {
    font-size: 1.25rem;
  }

  .gallery-grid {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }

  .gallery-image {
    height: 150px;
  }
}

@media (max-width: 480px) {
  .gallery-heading {
    font-size: 2rem;
  }

  .gallery-subheading {
    font-size: 1rem;
  }

  .gallery-grid {
    grid-template-columns: 1fr;
  }
}
</style>